/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { AwsRestoreAccountAttributes } from '../models/AwsRestoreAccountAttributes';
import { AzureRestoreAccountAttributes } from '../models/AzureRestoreAccountAttributes';
import { GcpRestoreAccountAttributes } from '../models/GcpRestoreAccountAttributes';
import { Provider } from '../models/Provider';

export class RestoreAccountCloudAttributes {
  'cloudProvider': Provider;
  'aws'?: AwsRestoreAccountAttributes | null;
  'gcp'?: GcpRestoreAccountAttributes | null;
  'azure'?: AzureRestoreAccountAttributes | null;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "cloudProvider",
      "baseName": "cloudProvider",
      "type": "Provider",
      "format": ""
    },
    {
      "name": "aws",
      "baseName": "aws",
      "type": "AwsRestoreAccountAttributes",
      "format": ""
    },
    {
      "name": "gcp",
      "baseName": "gcp",
      "type": "GcpRestoreAccountAttributes",
      "format": ""
    },
    {
      "name": "azure",
      "baseName": "azure",
      "type": "AzureRestoreAccountAttributes",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return RestoreAccountCloudAttributes.attributeTypeMap;
  }

  public constructor() {
  }
}



